import { useReleases } from "@/routes/simulator/context/release";
import { useUpdateSimulator } from "@/api/useRelease";
import { OptionalFieldGroup } from "./FieldGroup";
import { InlineNumberField } from "@/components/shared/inputs/inline-number-field/InlineNumberField";

export function UpdateTicketSimulatorNewConfigs() {
  const { simulator, refetchSimulators } = useReleases();

  const { mutateAsync: updateSimulator } = useUpdateSimulator({
    simulatorId: simulator?.id ?? 0,
  });

  return (
    <>
      <InlineNumberField
        label={"Response Timeout Window"}
        description={
          "Maximum time (in minutes) Quack has to respond to a message before skipping the ticket"
        }
        value={simulator?.timeDifferenceLimit ?? undefined}
        onChange={(newValue) =>
          newValue &&
          updateSimulator({
            name: simulator?.name,
            timeDifferenceLimit: newValue,
          })
        }
        placeholder={5}
        min={1}
        integer
      />

      <OptionalFieldGroup
        label={"Support File Attachments"}
        description={
          "Allow Quack to answer or skip tickets that include file attachments."
        }
        enabled={simulator?.allowRegularAttachments ?? false}
        toggleEnabled={async (nextValue) => {
          if (simulator?.id) {
            await updateSimulator({
              name: simulator.name,
              allowRegularAttachments: nextValue,
            });
            await refetchSimulators();
          }
        }}
      />

      <OptionalFieldGroup
        label={"Support Inline Files"}
        description={
          "Allow Quack to answer or skip tickets that include inline files."
        }
        enabled={simulator?.allowInlineAttachments ?? false}
        toggleEnabled={async (nextValue) => {
          if (simulator?.id) {
            await updateSimulator({
              name: simulator.name,
              allowInlineAttachments: nextValue,
            });
            await refetchSimulators();
          }
        }}
      />
    </>
  );
}
